// extracted by mini-css-extract-plugin
export default {"footerStyles":"modalFooter_footerStyles__hTLqm"};